<template>
  <base-form :title="$t('settings.candidates.settings.title')"
             :loading="loading"
             :show-footer="false"
             class="candidate-settings"
             @submit="submitForm">
    <template v-slot:content>
      <dl class="-mx-3">
        <div class="list-row"
             v-for="(value, key, index) in model"
             :class="{
               'bg-gray-50': index % 2 === 0,
               'bg-white': index % 2 === 1,
             }"
        >
          <dt class="list-row-dt">
            {{$t(`settings.general.candidate.${key}`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model[key]"
                         @input="submitForm"
            />
          </dd>
        </div>
      </dl>
    </template>
  </base-form>
</template>
<script>
  import settingsMixin from './settingsMixin'

  export default {
    name: 'job-settings',
    mixins: [settingsMixin],

    data () {
      return {
        loading: false,
        model: {
          app_job_alerts_send: false,
          app_job_alerts_location: false,
          app_job_alerts_search: false,
          app_resumes_enabled: false,
        }
      }
    },
    methods: {
      async submitForm () {
        let res = await this.$validator.validateAll()
        if (res) {
          try {
            this.loading = true
            await this.updateSettings()
            this.$notify({type: 'success', message: this.$t('settings.general.success')})
          } catch (e) {
            this.$notify({type: 'danger', message: this.$t('settings.general.error')})
          } finally {
            this.loading = false
          }
        }
      }
    }
  }
</script>
<style scoped>
  .candidate-settings .list-row {
    @apply py-4;
  }
</style>
